// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseExternalIdModel {
    static getAttributeTypeMap() {
        return CaseExternalIdModel.attributeTypeMap;
    }
}
CaseExternalIdModel.discriminator = undefined;
CaseExternalIdModel.attributeTypeMap = [
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "CaseExternalIdType"
    }
];
//# sourceMappingURL=caseExternalIdModel.js.map